import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/apyw/apywPerson/page`, params);
  },
  //列表数据-班级选择考生
  getChoosePage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/apyw/apywPerson/choosePage`, params);
  },
  // 列表数据-班级选择考生
  havaClassPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/apyw/apywPerson/havaClassPage`, params);
  },
  //列表数据-班级选择考生
  chooseOk(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/admin/apyw/apywPerson/chooseOk`, {params:params});
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/apyw/apywPerson/get/${params.id}`)
  },
  //保存修改
  saveOrUpdate(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPerson/set`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/apyw/apywPerson/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPerson/batchDel`,params)
  },
  //导入
  imp(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/apyw/apywPerson/imp`,params);
  },
  //保存考试
  saveExam(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPerson/saveExam`, params);
  },
  //归档
  setComplete(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPerson/setComplete`, params);
  },
  //copy数据
  copyInfo(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPerson/copyInfo`, params);
  },
  //copy数据
  exportExcelByIds(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPerson/exportExcelByIds`, params);
  },
}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/apywPerson.js